import React, { useState, useEffect } from 'react';
import SimpleHeader from '../../../components/Headers/SimpleHeader';

import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardHeader,
  CardBody,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
  FormGroup,
  Label
} from 'reactstrap';

import {
  icon_column_style,
  individual_column_style,
  individual_header_style,
  individual_icon_header_style
} from '../../../assets/styles/table_custom_style';

import { useHistory } from 'react-router-dom';

import ReactLoader from 'components/Loader';

import BootstrapTable from 'react-bootstrap-table-next';

import ToggleSwitch from 'components/ToggleSwitch/ToggleSwitch';

import ToolkitProvider from 'react-bootstrap-table2-toolkit';

import Pagination from 'components/Pagination';

import TeamService from '../service/index';

import { toast } from 'react-toastify';

export default function TeamList() {
  const history = useHistory();
  const [teams, setTeams] = useState([]);
  const [activePage, setActivePage] = useState(1);
  const [quantity, setQuantity] = useState(0);
  const [loading, setLoading] = useState(false);
  const [showDisabled, setShowDisable] = useState(false);
  const [searchTeams, setSearchTeams] = useState();

  async function loadApi(page = 1, querySearch = '') {
    await TeamService.getAllSeach(page, 10, querySearch, showDisabled)
      .then((res) => {
        setQuantity(res.data.totalRegisters);

        setLoading(false);
        setTeams(res.data.data);
      })
      .catch((err) => console.log(err));
  }

  useEffect(() => {
    loadApi();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showDisabled]);

  const changeActive = async (id, disabled) => {
    try {
      if (!disabled) {
        if (!window.confirm('Tem certeza que deseja desabilitar a equipe?'))
          return;
        await TeamService.changeStatus(id, true);
        toast.info('Equipe desabilitada com sucesso');
      } else {
        await TeamService.changeStatus(id, false);
        toast.info('Equipe habilitada com sucesso');
      }
      loadApi(activePage);
    } catch (err) {
      toast.error(
        err.response?.data?.errors?.[0] ||
          err.response?.data?.message ||
          'Ops algo errado aconteceu!',
        {
          autoClose: 3000,
          closeOnClick: true
        }
      );
    }
  };

  function handleUpdate(id) {
    history.push(`/admin/Team/form/${id}`);
  }

  const handlePageChange = (page) => {
    setActivePage(page);
    loadApi(page);
  };

  const getTeamsSearch = (event, selectedPage = 1) => {
    const value = event.target.value;
    setSearchTeams(value);
    if (value || value === '') {
      loadApi(selectedPage, value);
    }
  };

  return (
    <>
      <SimpleHeader
        setCreate="/admin/Team/form"
        name="List validation"
        parentName="List"
      />
      <Container className="mt--6" fluid>
        <Row className="mt-3 mx-2">
          <div className="col">
            <div className="card-wrapper">
              <Card>
                <CardHeader
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    gap: '1rem',
                    alignItems: 'center'
                  }}
                >
                  <h3>Equipe</h3>
                </CardHeader>
                <CardBody>
                  <Row>
                    <Col md="8">
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="fas fa-search" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          placeholder="Buscar equipe"
                          type="text"
                          value={searchTeams || ''}
                          onChange={(event) => getTeamsSearch(event)}
                        />
                      </InputGroup>
                    </Col>
                    <Col md="4" className="text-right mt-2 ">
                      <FormGroup check>
                        <Label check>
                          <Input
                            type="checkbox"
                            checked={showDisabled}
                            onChange={() => setShowDisable(!showDisabled)}
                          />
                          <span>Mostrar desabilitados</span>
                        </Label>
                      </FormGroup>
                    </Col>
                  </Row>
                </CardBody>
                <ToolkitProvider
                  data={teams}
                  keyField="id"
                  columns={[
                    {
                      dataField: 'name',
                      text: 'Nome',
                      sort: true,
                      style: individual_column_style,
                      headerStyle: individual_header_style
                    },
                    {
                      dataField: 'disabled',
                      style: icon_column_style,
                      headerStyle: individual_icon_header_style,
                      text: 'Habilitar / Desabilitar',
                      // eslint-disable-next-line react/display-name
                      formatter: (_, row) => {
                        return (
                          <ToggleSwitch
                            checked={!row.disabled}
                            id={row.id}
                            name={row.name}
                            onChange={() => changeActive(row.id, row.disabled)}
                          />
                        );
                      }
                    },
                    {
                      dataField: 'edit',
                      style: icon_column_style,
                      headerStyle: individual_icon_header_style,
                      text: 'Editar',
                      // eslint-disable-next-line react/display-name
                      formatter: (_, row) => {
                        return (
                          <Button
                            color="info"
                            size="sm"
                            title={'Editar Perfil'}
                            onClick={() => handleUpdate(row.id)}
                          >
                            <li className="fas fa-edit"></li>
                          </Button>
                        );
                      }
                    }
                  ]}
                >
                  {(props) => (
                    <div className="py-4 table-responsive">
                      {loading ? (
                        <Row className="justify-content-md-center">
                          <ReactLoader />
                        </Row>
                      ) : (
                        <BootstrapTable
                          {...props.baseProps}
                          bootstrap4={true}
                          bordered={false}
                          classes="align-items-center"
                        />
                      )}
                    </div>
                  )}
                </ToolkitProvider>
                <Pagination
                  activePage={activePage}
                  totalItemsCount={quantity}
                  onChange={handlePageChange.bind(this)}
                />
              </Card>
            </div>
          </div>
        </Row>
      </Container>
    </>
  );
}
